module.exports = __webpack_public_path__ + "img/allow-down-white.eb42c351.svg";